module.exports = __webpack_public_path__ + "assets/images/covid-hits-home-17.jpg?v=a60bce95";